import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'hourMinute'
})
export class HourMinutePipe extends DatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return super.transform(value,  'HH:mm' );
  }
}
